/**
 * 页面级代码加载中的loading
 */

import React, { Suspense, FC } from 'react';
import { BlockLoading } from 'component/BlockLoading/BlockLoading';

export const PageLoading: FC = function (props) {
    return (
        <Suspense fallback={<BlockLoading />}>{props.children}</Suspense>
    );
};
